export const viewportOptions = ["Entire Region", "San Francisco", "Berkeley", "Oakland"];

export const modelTypeOptions = ["block", "parcel", "zone"];

export const spatialReferenceSystemLegends = {
  label: "Spatial reference system (SRS)",
  infoContent: `Change the projected spatial reference system (SRS) that is used 
    to calculate areas in UrbanCanvas. Contact support@urbansim.com to change.`
};

export const templateLegends = {
  label: "Model template",
  infoContent: `The UrbanSim model template. The user interface will be configured 
  to expect information following this model template data schema. 
  Contact support@urbansim.com to change.`
};

export const baseYearLegends = {
  label: "Model base year",
  infoContent: "The base year of the UrbanSim model. Contact support@urbansim.com to change."
};

export const measurementIdLegends = {
  label: "Model system of measurement",
  infoContent: `The system of measurement natively recognized by the UrbanSim
   model. All data in the user interface will be sent to the model using this 
   system of measurement. Contact support@urbansim.com to change.`
};

export const residentialVacancyRateLegends = {
  label: "Residential Vacancy Rate",
  infoContent: `The default residential vacancy rate in the base year as a percentage.`
};

export const zoomLegends = {
  label: "Map zoom level",
  infoContent: `Change the default map zoom level for this region. All users 
   will be able to reset their map zoom level to this value when they recenter 
   the map to aid in map navigation. Contact support@urbansim.com to change.`
};

export const latitudeAndLongitudeLegends = {
  label: "Map latitude and longitude center",
  infoContent: `Change the default map latitude and longitude center location for 
    this region. All users will be able to recenter the map to this location 
    to aid in map navigation. Contact support@urbansim.com to change.`
};

export const basemapLegends = {
  label: "Basemap",
  infoContent: `Change the default basemap that is displayed in the user interface.`
};

export const userMeasurementSystemIdLegends = {
  label: "System of measurement",
  infoContent: `Change the default system of measurement used in the user interface.`
};

export const regionMeasurementSystemIdLegends = {
  label: "System of measurement",
  infoContent: `Change the default system of measurement used in the user interface. 
  Users can later customize this for their own user interface.`
};

export const defaultRegionLegends = {
  label: "Default region",
  infoContent: "Change settings for what UrbanCanvas region is shown by default when you login."
};

export const timeZoneLegends = {
  label: "Time zone",
  infoContent: `Change the default time zone used in the user interface.`
};
